<section>
  <div class="container py-16 flex flex-col gap-12">
    <div>
      <h1 class="text-2xl md:text-3xl font-semibold mb-2.5">{{ 'PAGES.TERMS.TITLE' | translate }}</h1>
      <div class="italic text-gray-500 text-sm">{{ 'PAGES.TERMS.LAST_UPDATE' | translate:{date: (lastUpdateDate | date)}
        }}
      </div>
    </div>

    <div class="flex flex-col gap-10 md:gap-14 lg:gap-24 md:flex-row-reverse">
      <div class="shrink-0 h-max md:sticky md:top-28">
        <h3 class="text-lg mb-2">{{ 'PAGES.TERMS.CONTENTS' | translate }}</h3>
        <ol class="font-medium  flex flex-col gap-2.5">
          <li class="underline"><a [routerLink]="['/terms']" [fragment]="'introduction'">{{ 'PAGES.TERMS.INTRODUCTION_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/terms']" [fragment]="'acceptance'">{{ 'PAGES.TERMS.ACCEPTANCE_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/terms']" [fragment]="'purpose'">{{ 'PAGES.TERMS.PURPOSE_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/terms']" [fragment]="'registration'">{{ 'PAGES.TERMS.REGISTRATION_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/terms']" [fragment]="'userCommitments'">{{ 'PAGES.TERMS.USER_COMMITMENTS_TITLE' | translate }}</a>
          </li>
          <li class="underline"><a [routerLink]="['/terms']" [fragment]="'pricing'">{{ 'PAGES.TERMS.PRICING_TITLE' | translate }}</a></li>
        </ol>
      </div>
      <div class="flex flex-col gap-8">

        <div class="scroll-mt-28" id="introduction">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.TERMS.INTRODUCTION_TITLE' | translate }}</h3>
          <p [innerHTML]="'PAGES.TERMS.INTRODUCTION' | translate"></p>
        </div>

        <div class="scroll-mt-28" id="acceptance">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.TERMS.ACCEPTANCE_TITLE' | translate }}</h3>
          <p>{{ 'PAGES.TERMS.ACCEPTANCE' | translate }}</p>
        </div>

        <div class="scroll-mt-28" id="purpose">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.TERMS.PURPOSE_TITLE' | translate }}</h3>
          <p>{{ 'PAGES.TERMS.PURPOSE' | translate }}</p>
        </div>

        <div class="scroll-mt-28" id="registration">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.TERMS.REGISTRATION_TITLE' | translate }}</h3>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.TERMS.REGISTRATION' | translate); track $index) {
            <li>{{ item }}</li>
            }
          </ul>
        </div>

        <div class="scroll-mt-28" id="userCommitments">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.TERMS.USER_COMMITMENTS_TITLE' | translate }}</h3>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            <li>
              <div class="text-lg font-inter font-medium mb-2">{{ 'PAGES.TERMS.USER_COMMITMENTS_CLIENTS' | translate }}
              </div>
              <ul class="flex flex-col gap-1 pl-7 list-disc">
                @for (item of ('PAGES.TERMS.USER_COMMITMENTS_CLIENTS_LIST' | translate); track $index) {
                <li>{{ item }}</li>
                }
              </ul>
            </li>
            <li>
              <div class="text-lg font-inter font-medium mb-2">{{ 'PAGES.TERMS.USER_COMMITMENTS_HAIRDRESSERS' |
                translate }}
              </div>
              <ul class="flex flex-col gap-1 pl-7 list-disc">
                @for (item of ('PAGES.TERMS.USER_COMMITMENTS_HAIRDRESSERS_LIST' | translate); track $index) {
                <li>{{ item }}</li>
                }
              </ul>
            </li>
          </ul>
        </div>

        <div class="scroll-mt-28" id="pricing">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.TERMS.PRICING_TITLE' | translate }}</h3>
          <p>{{ 'PAGES.TERMS.PRICING' | translate }}</p>
        </div>

      </div>
    </div>
  </div>
</section>